import React, { FC, useContext } from 'react';

import { Button } from '@smartshell/ui-kit';
import { NavLink } from 'react-router-dom';

import { LocalizationContext } from 'localization';

import s from './ApplicationTop.module.scss';
import { ApplicationTopProps } from './interfaces';

const ApplicationTop: FC<ApplicationTopProps> = ({
  OpenTabRadio,
  link,
  linkTitle,
  openModal,
  closeAllGroups,
  disabledCloseButton,
}) => {
  const { t } = useContext(LocalizationContext);

  return (
    <div className={s.container}>
      {OpenTabRadio}
      <div className={s.links}>
        <Button
          variant="outline"
          onClick={closeAllGroups}
          disabled={disabledCloseButton}
        >
          {t('applications.groups.hide')}
        </Button>
        <Button iconName="EditIcon" onClick={openModal} variant="secondary">
          {t('applications.groups.edite.title')}
        </Button>
        <NavLink to={link}>
          <Button iconName="CirclePlusIcon">{linkTitle}</Button>
        </NavLink>
      </div>
    </div>
  );
};

export default ApplicationTop;
